import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import * as moment from "moment";
import { DotLoader } from "react-spinners";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import "react-month-picker/css/month-picker.css";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import {
    documentoEmpleador,
    tipoDocumentoEmpleador,
    tipoTransaccion,
    fechaInicialConsulta,
    fechaFinalConsulta,
    estadosProceso
} from "../../config_general/modelo/TextosAyuda";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { FiltroConsultaMasiva } from "../modelo/ConsultaReciboNovedades";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { EstadoReciboSAT } from "../../config_general_recibo/modelo/EstadoReciboSAT";
import { consultarServiciosReciboSat } from "../../../general/modulos/maestrosActions";
import {
    generarConsultaNovedadesRecibidasFtp,
    limpiarMensajesEstado,
    enviarCambioEstadoMasivo,
    descargarPlantillaMasivoEstado
} from "../modulos/consultaNovedadesRecibidasActions";
import MensajeConAccion from "../../../general/componentes/MensajeConAccion";
import { listarServicios, listaEstadosReciboSAT } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import DivisorConTexto from "../../config_general/componentes/DivisorConTexto";

class ConsultaNovedadesRecibidas extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            fileUpload: React.createRef(),
            archivo: null,
            archivoCorrecto: false,
            estadoCarga: REQUEST.NONE
        };
    }

    componentWillMount() {
        if (!this.props.serviciosReciboSat || this.props.serviciosReciboSat.length === 0) {
            this.props.dispatch(consultarServiciosReciboSat());
        }
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesEstado());
    }

    render() {

        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Masiva Novedades Recibidas SAT (FTP)</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta masiva Excel</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoTransaccion">Tipo de Transacción</label>
                                                <TextoAyuda texto={tipoTransaccion} />
                                                <TextoInputSelector name="tipoTransaccion" maestro={listarServicios(this.props.serviciosReciboSat)} />
                                                {errors.tipoTransaccion &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoTransaccion}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Inicial de Operación</label>
                                                <TextoAyuda texto={fechaInicialConsulta} />
                                                <DatePickerSura name={"fechaInicial"} fechaMaxima={moment()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Final de Operación</label>
                                                <TextoAyuda texto={fechaFinalConsulta} />
                                                <DatePickerSura name={"fechaFinal"} fechaMaxima={moment()} />
                                            </Col>
                                        </Row>
                                        <DivisorConTexto texto="opcional" />
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TextoAyuda texto={tipoDocumentoEmpleador} />
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <TextoAyuda texto={documentoEmpleador} />
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={9}>
                                                <label>Estados</label>
                                                <TextoAyuda texto={estadosProceso} />
                                                <TextoInputSelector name="estados" selectorMultiple maestro={listaEstadosReciboSAT(EstadoReciboSAT)} />
                                                {errors.estados &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.estados}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col smOffset={9} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                    disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                    <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {
                                        this.renderEstadoGenerarFtp()
                                    }
                                </Row>
                                <br />
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Envió Masivo Cambio de Estado</h3>
                                    </div>
                                    <div className={"card-body"} style={{ marginTop: '30px' }}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <a className="btns btn-success" onClick={this.descargarPlantillaXLS} >
                                                    <b>Plantilla Excel</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                </a>
                                            </Col>
                                            <Col sm={3}>
                                                <a className="btns btn-primary" onClick={this.cargarArchivoXLSMasivo} >
                                                    <input type="file" ref={this.state.fileUpload} name="archivo"
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{ display: "none" }} />
                                                    <b>Cargar Excel</b> &nbsp;<Glyphicon className={"upload"} glyph={"upload"} />
                                                </a>
                                            </Col>
                                            <Col smOffset={3} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={this.resetFile}
                                                    disabled={!this.state.archivoCorrecto}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <button className="btns btns-primary" style={{ width: '142px' }} onClick={this.enviarMasivo} disabled={!this.state.archivoCorrecto}>
                                                    <b>Enviar Masivo</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {this.renderPestañaEstadoCarga()}
                                    {this.renderEstadoEnvioMasivo()}
                                </Row>
                            </form>
                        )}
                    />
                </Row>
            </div>
        );
    }

    renderEstadoGenerarFtp() {
        const { estadoGenerarConsultaFTP, registrosEncontrados, mensajeUsuario } = this.props;

        switch (estadoGenerarConsultaFTP) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                        <br />
                    </div>);
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <MensajeConAccion type={"success"}
                            mensaje={`Se realizó la consulta con éxito y se encontraron ${registrosEncontrados} registros con los filtros seleccionados.`}
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    renderPestañaEstadoCarga() {
        switch (this.state.estadoCarga) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={" El archivo no se cargó porque no cumple con el formato o el tamaño de 1 Megabytes."} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <MensajeConAccion type={"success"} mensaje={" El archivo se cargó con exito."} />
                    </span>
                );
            default:
                return false;
        }
    }

    renderEstadoEnvioMasivo() {
        const { estadoEnvioMasivo, mensajeUsuario } = this.props;
        switch (estadoEnvioMasivo) {
            case REQUEST.ERROR:
                return <MensajeConAccion type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <MensajeConAccion type={"success"}
                            mensaje="Se realizó la carga de la información exitosamente esta se encuentra en proceso de envío."
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    descargarPlantillaXLS = () => {
        this.props.dispatch(descargarPlantillaMasivoEstado());
    }

    cargarArchivoXLSMasivo = () => {
        const fileUpload = this.state.fileUpload.current;
        fileUpload.value = null;
        fileUpload.click();
        fileUpload.onchange = (e) => {
            this.validarXLS(e.target.files[0]);
        };
    }

    validarXLS = (file: File) => {
        if (file) {
            const nombre = file.name;
            const extencion = nombre.substring(nombre.length - 4, nombre.length);
            const tamano = file.size;
            if (extencion !== "xlsx" || tamano > 1000000) {
                this.setState({
                    estadoCarga: REQUEST.ERROR,
                    archivo: null,
                    archivoCorrecto: false
                });
                return;
            }
            this.setState({
                estadoCarga: REQUEST.SUCCESS,
                archivo: file,
                archivoCorrecto: true
            });
        }
    };

    resetFile = () => {
        this.setState({
            estadoCarga: REQUEST.NONE,
            archivo: null,
            archivoCorrecto: false
        });
    };

    enviarMasivo = () => {
        if (this.state.archivoCorrecto) {
            this.props.dispatch(enviarCambioEstadoMasivo(this.state.archivo));
        }
        this.resetFile();
    };

    onSubmit = (values: any) => {
        this.props.dispatch(generarConsultaNovedadesRecibidasFtp(this.obtenerValores(values)));
    };

    obtenerValores = (values: any) => {
        const dni = (values.tipoDocumento && values.documento) ? (values.tipoDocumento + values.documento) : undefined;
        const fechaInicial = values.fechaInicial ? values.fechaInicial.format("YYYY-MM-DD").valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.format("YYYY-MM-DD").valueOf() : "";
        const tipoTransaccion = values.tipoTransaccion ? Number(values.tipoTransaccion.value) : undefined;
        const estados = (values.estados) ? values.estados.map(estado => estado.value) : undefined;

        const filtro: FiltroConsultaMasiva = {
            dniEmpleador: dni,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            servicio: tipoTransaccion,
            estados: estados,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };

        return filtro;
    };

    validate = (values: any) => {
        const errors = {
            fechaInicial: undefined,
            fechaFinal: undefined,
            tipoTransaccion: undefined
        };
        if (!values.tipoTransaccion)
            errors.tipoTransaccion = "Por favor seleccione un opcion";

        if (values.tipoTransaccion && !values.fechaInicial)
            errors.fechaInicial = "Por favor seleccione una fecha";

        if (values.tipoTransaccion && values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor seleccione una fecha";

        if (values.fechaInicial && values.fechaFinal && values.fechaInicial.isAfter(values.fechaFinal)) {
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
        }

        return errors;
    };
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoGenerarConsultaFTP: R.pathOr(undefined, ["recibo_novedades_masivo", "estadoGenerarConsultaFTP"])(store),
        mensajeUsuario: R.pathOr(undefined, ["recibo_novedades_masivo", "mensajeUsuario"])(store),
        registrosEncontrados: R.pathOr(undefined, ["recibo_novedades_masivo", "registrosEncontrados"])(store),
        registrosParametro: R.pathOr(undefined, ["recibo_novedades_masivo", "registrosParametro"])(store),
        correos: R.pathOr(undefined, ["recibo_novedades_masivo", "correos"])(store),
        serviciosReciboSat: R.pathOr([], ["maestros", "serviciosReciboSat"])(store)
    };
})(ConsultaNovedadesRecibidas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_masivo/componente/ConsultaNovedadesRecibidas.tsx